export default {
  SIMPLE: '@YOLA_TEMPLATE_GALLERY/DIALOG/SIMPLE',
  SITE_LIMIT: '@YOLA_TEMPLATE_GALLERY/DIALOG/SITE_LIMIT',
  HELP_DISPLAYED: '@YOLA_TEMPLATE_GALLERY/DIALOG/HELP_DISPLAYED',
  FILTER_TEMPLATES_DIALOG: '@YOLA_TEMPLATE_GALLERY/DIALOG/FILTER_TEMPLATES_DIALOG',
};
